var map = {
	"./logo-aberdeenlive.svg": 2239,
	"./logo-accrington.svg": 4074,
	"./logo-bedfordshirelive.svg": 5359,
	"./logo-belfastlive.svg": 991,
	"./logo-birminghammail.svg": 7766,
	"./logo-birminghampost.svg": 5675,
	"./logo-bristolpost.svg": 5610,
	"./logo-buckinghamshirelive.svg": 6173,
	"./logo-burtonmail.svg": 3066,
	"./logo-businessInsider.svg": 8154,
	"./logo-buzz.svg": 9867,
	"./logo-cambridgenews.svg": 2017,
	"./logo-chesterchronicle.svg": 5670,
	"./logo-corkbeo.svg": 6235,
	"./logo-corklive.svg": 9727,
	"./logo-cornwalllive.svg": 8275,
	"./logo-coventrytelegraph.png": 4904,
	"./logo-coventrytelegraph.svg": 7103,
	"./logo-curiously.svg": 4097,
	"./logo-dailyrecord.svg": 8754,
	"./logo-dailystar.svg": 4554,
	"./logo-derbytelegraph.svg": 6470,
	"./logo-devonlive.svg": 1697,
	"./logo-dorsetlive.svg": 5754,
	"./logo-dublinlive.svg": 6100,
	"./logo-edinburghlive.svg": 2720,
	"./logo-essexlive.svg": 3383,
	"./logo-express.svg": 2996,
	"./logo-footballlondon.svg": 5533,
	"./logo-footballscotland.svg": 4019,
	"./logo-galwaybeo.svg": 9083,
	"./logo-gazettelive.svg": 9717,
	"./logo-getreading.svg": 3737,
	"./logo-getsurrey.svg": 2894,
	"./logo-getwestlondon.svg": 7184,
	"./logo-glasgowlive.svg": 285,
	"./logo-gloucestershirelive.svg": 9211,
	"./logo-grimsbytelegraph.svg": 9192,
	"./logo-hampshirelive.svg": 2972,
	"./logo-hertfordshiremercury.svg": 9592,
	"./logo-hertslive.svg": 6490,
	"./logo-hulldailymail.svg": 9801,
	"./logo-inyourarea.svg": 352,
	"./logo-irishmirror.svg": 6695,
	"./logo-irishstar.svg": 7163,
	"./logo-kentlive.svg": 3734,
	"./logo-leedslive.svg": 1403,
	"./logo-leicestermercury.svg": 1244,
	"./logo-lincolnshirelive.svg": 1504,
	"./logo-liverpool.svg": 5266,
	"./logo-liverpoolecho.svg": 8528,
	"./logo-men.svg": 7728,
	"./logo-mirror.svg": 2229,
	"./logo-nechronicle.svg": 182,
	"./logo-norfolklive.svg": 7775,
	"./logo-northantslive.svg": 4929,
	"./logo-northwales.svg": 5006,
	"./logo-nottinghampost.svg": 5237,
	"./logo-ok.svg": 8181,
	"./logo-oxfordshirelive.svg": 5317,
	"./logo-plymouthherald.svg": 3474,
	"./logo-reach-footer.png": 140,
	"./logo-reach.svg": 2187,
	"./logo-rsvp.svg": 3944,
	"./logo-scottishdailyexpress.svg": 2750,
	"./logo-somersetlive.svg": 486,
	"./logo-staffordshirelive.svg": 8021,
	"./logo-stokesentinel.svg": 7613,
	"./logo-suffolklive.svg": 6403,
	"./logo-sussexlive.svg": 3827,
	"./logo-the-express.svg": 4623,
	"./logo-themirror.svg": 7677,
	"./logo-walesonline.svg": 9237,
	"./logo-wiltshirelive.svg": 7049,
	"./logo-yorkshire-live.svg": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5106;